var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerSelect3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 4190 5070",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,-1) translate(0,-5070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641 5043 c-18 -9 -42 -31 -52 -47 -18 -30 -19 -104 -19 -2396 0 -2328 0 -2366 20 -2397 51 -84 180 -83 236 3 17 25 18 92 15 1145 l-3 1119 24 10 c12 6 749 221 1637 479 1761 513 1657 478 1682 562 14 46 0 95 -39 132 -33 31 -3395 1407 -3438 1407 -16 0 -44 -8 -63 -17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerSelect3);
export default __webpack_public_path__ + "static/media/markerSelect3.766ae7717d5a6c755e21dd1f46bc33dc.svg";
export { ForwardRef as ReactComponent };